import { EodSupportApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useEodDevices = (userId: string) => {
  const [eodDevices] = useAPIAction(
    EodSupportApi,
    // WHAT: fetches this user's EOD Connect machines.
    // WHY a parameter instead of a hardcoded `true`: `allUserMachines` maps
    // straight to the API's `all_user_machines` flag. It used to always be
    // `true`, which meant every user (sub-user or not) silently got back
    // their parent account's full machine list on first load. Now the
    // caller decides — SummitWorkspace defaults it to `false` and only
    // flips it to `true` when the rep explicitly ticks "Show all machines"
    // for a sub-user.
    async (api, allUserMachines: boolean) => {
      let response = await api.eodMachines({
        allUserMachines,
      });
      return {
        successMessages: [],
        data: response,
      };
    },
    {
      defaultApiConfigOptions: {
        impersonationForId: userId
      },
      translationPrefix: "",
    }
  );
  return useCallback(async (allUserMachines: boolean) => {
    return await eodDevices(allUserMachines);
  }, [eodDevices]);
};
